import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { investmentLogic } from '@/mocks/invest';

export default function InvestmentLogic() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="投资逻辑"
            title="为什么值得关注九畴云铺"
            subtitle="政策确定性、场景已验证、标准化复制、技术壁垒与生态协同，构成项目的核心投资逻辑。"
          />
        </Reveal>

        <div className="mt-12 space-y-4">
          {investmentLogic.map((item, i) => (
            <Reveal key={item.title} delay={i * 60}>
              <div className="flex items-start gap-5 p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
                <div className="w-14 h-14 rounded-lg bg-primary-500 flex items-center justify-center shrink-0">
                  <i className={`${item.icon} text-background-50 text-2xl`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="font-heading font-bold text-lg text-foreground-950">{item.title}</h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
                <span className="hidden sm:block font-heading font-bold text-3xl text-background-200">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}